<template>
  <div>
    <md-toolbar class="md-warn">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <b>EXECUTION LOG of {{ name }} </b>&nbsp;<i>{ id: {{ this.$route.params.id }} }</i>
        </div>
      </div>
    </md-toolbar>
    <md-progress-bar
      v-if="searching"
      md-mode="indeterminate"
    ></md-progress-bar>

    <md-card class="md-layout-item">
      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-100">
            <md-datepicker
              v-model="from"
              :md-open-on-focus="false"
              :md-model-type="String"
              :md-immediately="true"
              :md-debounce="1000"
            >
              <label>From (UTC)</label>
            </md-datepicker>
          </div>
          <div class="md-layout-item md-small-size-100">
            <md-datepicker
              v-model="to"
              :md-open-on-focus="false"
              :md-model-type="String"
              :md-immediately="true"
              :md-debounce="1000"
            >
              <label>To (UTC)</label>
            </md-datepicker>
          </div>
          <div class="md-layout-item md-small-size-100">
            <md-field>
              <label for="movie">Level</label>
              <md-select v-model="level">
                <md-option value="">ALL</md-option>
                <md-option value="ERROR">ERROR</md-option>
                <md-option value="WARNING">WARNING</md-option>
                <md-option value="INFO">INFO</md-option>
              </md-select>
            </md-field>
          </div>
        </div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-100">
            <md-field md-clearable>
              <label>Invocation ID</label>
              <md-input v-model="invocationId"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100">
            <md-field md-clearable>
              <label>Search Field 1</label>
              <md-input v-model="searchField1"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100">
            <md-field md-clearable>
              <label>Search Field 2</label>
              <md-input v-model="searchField2"></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100">
            <md-field md-clearable>
              <label>Search Field 3</label>
              <md-input v-model="searchField3"></md-input>
            </md-field>
          </div>
        </div>
      </md-card-content>
    </md-card>
    <md-table
      v-model="logs"
      md-sort-order="asc"
      md-sort="RowKey"
      md-card
      md-height="100%"
    >
      <md-table-toolbar>
        <h1 class="md-title info-about">Result contains first {{ number }} <i>latest</i> matching messages</h1>
        <md-button
          class="md-dense"
          @click="expandAll"
        >Expand all</md-button>
        <md-button
          class="md-dense"
          @click="collapseAll"
        >Collapse all</md-button>
        <md-button
          class="md-dense md-primary md-raised"
          ref="srch_button"
          @click="fetchLogs"
        >SEARCH LOG ITEMS
        </md-button>
      </md-table-toolbar>

      <md-table-row
        slot="md-table-row"
        slot-scope="{ item }"
      >
        <md-table-cell
          md-label="Time (UTC)"
          md-sort-by="RowKey"
        >{{ item.Timestamp }}</md-table-cell>
        <md-table-cell
          md-label="Level"
          md-sort-by="Level"
        >
          <md-chip v-if="item.Level == 'INFO'">INFO</md-chip>
          <md-chip
            v-if="item.Level == 'WARNING'"
            class="md-primary"
          >WARNING</md-chip>
          <md-chip
            v-if="item.Level == 'ERROR'"
            class="md-accent"
          >ERROR</md-chip>
          <md-chip
            v-if="item.Level == 'CRITICAL'"
            class="md-accent"
          >CRITICAL</md-chip>
        </md-table-cell>
        <md-table-cell
          md-label="Invocation ID"
          md-sort-by="InvocationId"
        >
          <a
            class="pointer"
            @click="showInvocation(item.InvocationId)"
          >
            {{ item.InvocationId }}
          </a>

        </md-table-cell>
        <md-table-cell
          md-label="Message"
          md-sort-by="LogMessage"
        >
          <div v-if="item.LogMessage.length < 128">{{ item.LogMessage }}</div>
          <div v-else>
            {{ item.LogMessage.substring(0, 128) }}
            <span v-if="item.collapsed">...<a
                class="pointer"
                @click="item.collapsed = false;"
              ><b><i>(show
                    more)</i></b></a></span>
            <span v-else>{{ item.LogMessage.slice(128) }}
              <a
                class="pointer"
                @click="item.collapsed = true;"
              ><b><i>(show less)</i></b></a></span>
          </div>
        </md-table-cell>
        <md-table-cell
          md-label="Search Field 1"
          md-sort-by="SearchField1"
        >{{ item.SearchField1 }}</md-table-cell>
        <md-table-cell
          md-label="Search Field 2"
          md-sort-by="SearchField2"
        >{{ item.SearchField2 }}</md-table-cell>
        <md-table-cell
          md-label="Search Field 3"
          md-sort-by="SearchField3"
        >{{ item.SearchField3 }}</md-table-cell>
      </md-table-row>
    </md-table>
    <md-dialog
      class="details"
      :md-active.sync="showInvocationDetails"
    >
      <md-card>
        <md-card-header>
          <div class="md-title">Invocation {{dialogInvocationId}}</div>
        </md-card-header>

        <md-card-content>
          Dowload invocation data: <a
            href="#"
            @click="downloadInvocation(dialogInvocationId)"
          >event_data.json</a> or
          <a
            href="#"
            @click="downloadInvocation(dialogInvocationId, 'py')"
          >event_data.py</a>
        </md-card-content>

        <md-card-actions>
        </md-card-actions>
      </md-card>
      <md-progress-bar
        class="md-accent"
        md-mode="indeterminate"
        v-if="invocationLoader"
      ></md-progress-bar>

      <md-table ref="invocationLogs">

        <md-table-row
          v-for="inv in currentInvocation"
          :key="inv.RowKey"
        >
          <md-table-cell
            md-label="Time (UTC)"
            md-sort-by="RowKey"
          >{{ inv.Timestamp }}</md-table-cell>

          <md-table-cell
            md-label="Level"
            md-sort-by="Level"
          >
            <md-chip v-if="inv.Level == 'INFO'">INFO</md-chip>
            <md-chip
              v-if="inv.Level == 'WARNING'"
              class="md-primary"
            >WARNING</md-chip>
            <md-chip
              v-if="inv.Level == 'ERROR'"
              class="md-accent"
            >ERROR</md-chip>
            <md-chip
              v-if="inv.Level == 'CRITICAL'"
              class="md-accent"
            >CRITICAL</md-chip>
          </md-table-cell>
          <md-table-cell>
            <div v-if="inv.LogMessage.length < 128">{{ inv.LogMessage }}</div>
            <div v-else>
              {{ inv.LogMessage.substring(0, 128) }}
              <span v-if="!inv.opened">...<a
                  class="pointer"
                  @click="inv.opened = true;"
                ><b><i>(show
                      more)</i></b></a></span>
              <span v-else>{{ inv.LogMessage.slice(128) }}
                <a
                  class="pointer"
                  @click="inv.opened = false;"
                ><b><i>(show less)</i></b></a></span>
            </div>
          </md-table-cell>
        </md-table-row>

      </md-table>

      <md-dialog-actions>
        <md-button
          class="md-primary md-raised"
          @click="showInvocation(dialogInvocationId)"
          :disabled=invocationLoader
        >Refresh logs</md-button>
        <md-button
          class="md-primary md-accent md-raised"
          :disabled=invocationLoader
          @click="runInvocation(dialogInvocationId)"
        >&#9888 Retry running automation &#9888</md-button>
        <md-button
          class="md-primary"
          @click="showInvocationDetails = false"
        >Close</md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog-alert
      :md-active.sync="runScriptDialog"
      md-content="Your script has been executed succesfully!"
      md-confirm-text="Ok"
    />
    <md-dialog-alert
      :md-active.sync="errorDialogShow"
      :md-content="errorMsg"
      md-confirm-text="Ok"
    />
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";

const BASE_URL = process.env.VUE_APP_FUNCTIONURL;

export default {
  name: "Log",
  components: {},
  data: () => ({
    name: "loading....",
    searching: false,
    errorMsg: "",
    errorDialogShow: false,

    showInvocationDetails: false,
    currentInvocation: [],
    dialogInvocationId: null,
    invocationLoader: false,
    runScriptDialog: false,

    logs: [],
    number: 1000,
    from: "",
    to: "",
    level: "",
    invocationId: "",
    searchField1: "",
    searchField2: "",
    searchField3: "",
  }),
  async mounted() {},
  created() {
    if (this.$route.params.number) this.number = this.$route.params.number;
    this.$material.locale.dateFormat = "yyyy-MM-dd HH:mm:ss";
    //this.from = moment(Date.now() - 7 * 24 * 3600 * 1000).format(
    //  "YYYY-MM-DD HH:MM:SS"
    //);
    this.fetchLogs();
  },
  computed: {},
  methods: {
    callApi(url, body, success, errMsg) {
      self = this;
      (body ? axios.post(url, body) : axios.get(url))
        .then((response) => success(response))
        .catch((error) => {
          self.errorDialogShow = true;
          self.errorMsg = errMsg;
          console.log(errMsg + "\n" + error);
        });
    },
    fetchLogs() {
      console.log(this.from);
      this.searching = true;
      setTimeout(() => {
        this.callApi(
          `${BASE_URL}/api/logs?company=${this.$route.params.company}&id=${
            this.$route.params.id
          }&number=${this.number ?? 10000}`,
          Object.assign(
            {},
            this.from && this.from !== ""
              ? { from: this.from.replace(" ", "T") + "Z" }
              : null,
            this.to && this.to !== ""
              ? { to: this.to.replace(" ", "T") + "Z" }
              : null,
            this.level && this.level !== "" ? { Level: this.level } : null,
            this.invocationId && this.invocationId !== ""
              ? { InvocationId: this.invocationId }
              : null,
            this.searchField1 && this.searchField1 !== ""
              ? { SearchField1: this.searchField1 }
              : null,
            this.searchField2 && this.searchField2 !== ""
              ? { SearchField2: this.searchField2 }
              : null,
            this.searchField3 && this.searchField3 !== ""
              ? { SearchField3: this.searchField3 }
              : null
          ),
          (response) => {
            response.data.logs.forEach(function (e) {
              e.collapsed = true;
            });

            this.logs = response.data.logs; //JSON.parse(JSON.stringify(response.data)); // json clone
            this.searching = false;
            this.name = response.data.name;
          },
          "Error happened while loading logs"
        );
      }, 1000);
    },
    expandAll() {
      this.collapsed = false;
      this.logs.forEach(function (e) {
        e.collapsed = false;
      });
    },
    collapseAll() {
      this.collapsed = true;
      this.logs.forEach(function (e) {
        e.collapsed = true;
      });
    },
    showInvocation(id) {
      this.invocationLoader = true;
      this.dialogInvocationId = id;
      this.currentInvocation = [];
      this.showInvocationDetails = true;
      this.callApi(
        `${BASE_URL}/api/logs?company=${this.$route.params.company}&id=${
          this.$route.params.id
        }&number=${this.number ?? 10000}`,
        { InvocationId: this.dialogInvocationId },
        (response) => {
          response.data.logs.forEach(function (e) {
            e.opened = false;
          });
          this.currentInvocation = response.data.logs.reverse();
          this.invocationLoader = false;
          this.$nextTick(() => {
            let tb = this.$refs.invocationLogs.$el.children[0];
            tb.scrollTop = tb.scrollHeight;
          });
        },
        "Error happened while loading logs"
      );
    },
    downloadInvocation(id, format = "json") {
      this.invocationLoader = true;
      this.callApi(
        `${BASE_URL}/api/invocation?company=${this.$route.params.company}&id=${this.dialogInvocationId}` +
          (format == "json" ? "" : "&python=true"),
        null,
        (response) => {
          this.download("event_data." + format, response.data);
          this.invocationLoader = false;
        },
        "Error happened while downloading invocation event data"
      );
    },

    download(filename, text) {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);
      element.setAttribute("target", "_blank");
      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },
    runInvocation(id) {
      this.invocationLoader = true;
      let self = this;

      axios
        .get(
          `${BASE_URL}/api/invocation?id=${id}&company=${this.$route.params.company}`
        )
        .then((response) => {
          let eventJSON = response.data;
          console.log(eventJSON);
          // CALLING FUNCTION WITH EVENT JSON
          axios
            .post(
              `${BASE_URL}/api/automate?ignoredisabled=true&logicId=${self.$route.params.id}&company=${self.$route.params.company}`,
              eventJSON
            )
            .then((response) => {
              self.runScriptDialog = true;
              self.invocationLoader = false;
              console.log(response);
            })
            .catch((error) => {
              self.invocationLoader = false;
              console.log(error);
              if (error.response) self.errorMsg = error.response.data;
              else self.errorMsg = String(error);
              self.errorDialogShow = true;
            });
        })
        .catch((error) =>
          console.log("ERROR LOADING INVOCATION BODY:\n" + error)
        );
    },
  },
};
</script>
<style lang="css" scoped>
.md-table-cell {
  height: 16px !important;
  line-height: 16px !important;
}

.md-table-cell {
  font-family: monospace;
}
.info-about {
  color: #aaaaaa !important;
}

.details > .md-dialog-container {
  max-width: 100% !important;
  width: 100% !important;
}
</style>
<style lang="css">
.details > .md-dialog-container {
  max-width: 100% !important;
  width: 95% !important;
  max-height: 100% !important;
  height: 95% !important;
}

.details .md-table {
  height: 100% !important;
}
</style>
